const warnedMalformedGeometryContexts = new Set<string>();

export interface MapLatLngLike {
  lat: number;
  lng: number;
  alt?: number;
}

export const isValidLatLng = (
  latlng: MapLatLngLike | null | undefined
): latlng is MapLatLngLike =>
  !!latlng && Number.isFinite(latlng.lat) && Number.isFinite(latlng.lng);

const latLngToCoords = (
  latlng: MapLatLngLike
): [number, number] | [number, number, number] => {
  if (latlng.alt !== undefined && Number.isFinite(latlng.alt)) {
    return [latlng.lng, latlng.lat, latlng.alt];
  }

  return [latlng.lng, latlng.lat];
};

export const getValidSegmentCoords = (
  coord: MapLatLngLike | null | undefined,
  nextCoord: MapLatLngLike | null | undefined,
  context: string
): [[number, number] | [number, number, number], [number, number] | [number, number, number]] | null => {
  if (!isValidLatLng(coord) || !isValidLatLng(nextCoord)) {
    if (!warnedMalformedGeometryContexts.has(context)) {
      console.warn(`Skipping malformed map geometry segment in ${context}`);
      warnedMalformedGeometryContexts.add(context);
    }
    return null;
  }

  return [latLngToCoords(coord), latLngToCoords(nextCoord)];
};
